import React from 'react';
import { Navigate, RouteObject } from 'react-router';
import { ERoutes } from '../types';

const ErrorRoutes: RouteObject = {
  path: ERoutes.any,
  element: <Navigate to='/' replace />,
};

export default ErrorRoutes;
